import { withRelatedProject } from '@vercel/related-projects'
import { env } from '~/env.ts'
import { mergePaths } from '~/lib/utils.ts'

export const apiHost = withRelatedProject({
  projectName: 'aikoa-app-api',
  /**
   * Specify a default host that will be used for my-api-project if the related project
   * data cannot be parsed or is missing.
   */
  defaultHost: mergePaths(env.EXPO_PUBLIC_API_URL, env.EXPO_PUBLIC_API_PATH),
})
